export const ALLOCATION_PERIOD_OVERLAP_TYPE = {
  PARTIAL: 'PARTIAL',
  FULL: 'FULL',
  NONE: 'NONE'
};
